import { Breadcrumb as _Breadcrumb, BreadcrumbItem } from './Breadcrumb';
const Breadcrumb = _Breadcrumb;
Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;
